import { isVelaStatus } from '../listings/statuses';
import request from './request';

import { CHANNEL_ID, EBAY, ETSY, FAIRE } from '../../constants/channels';
import { ENDPOINT } from '../../constants/api';

export function getById({ channel, db, payload, shopId, signal }) {
  return new Promise(function executor(resolve, reject) {
    request
      .post({
        endpoint: channel === EBAY || channel === FAIRE
          ? ENDPOINT.WEB_V2
          : ENDPOINT.WEB,
        params: { db },
        payload,
        signal,
        url: channel === EBAY || channel === FAIRE
          ? `/${channel}/shops/${shopId}/products`
          : `/shops/${shopId}/products`,
      })
      .then(
        function onProducts(data) {
          if (channel === FAIRE || !data.count) {
            data.videos = [];
            return resolve(data);
          }

          request
            .post({
              endpoint: ENDPOINT.WEB_V2,
              params: { db },
              payload: { listing_ids: data.products },
              signal,
              url: `/videos/${channel}/${shopId}/search`,
            })
            .then(
              function onVideos(videos) {
                data.videos = videos.data;
                resolve(data);
              },
              reject,
            );
        },
        reject,
      );
  });
}

export async function copyProducts({ db, payload, shopId }) {
  return request.post({
    url: `/shops/${shopId}/products/copy`,
    payload: payload,
    params: { db },
  });
}

export async function getLinkedProducts({ db, linkId, productId, signal }) {
  return request.get({
    params: { db },
    signal,
    url: `/products/${productId}/mergedProducts/${linkId}`,
  });
}

export async function bulkEditProducts({ channel, db, operations, params, shopId, status }) {
  const payload = channel === EBAY || channel === FAIRE
    ? { operations, saveOnly: isVelaStatus({ channel, status }) }
    : operations;

  return request.put({
    url: `/shops/${shopId}/products`,
    params: { db, editType: 'bulk', ...params },
    payload,
  });
}

export async function editSingleProduct({ channel, db, operations, shopId, params, status }) {
  const payload = channel === EBAY || channel === FAIRE
    ? { operations, saveOnly: isVelaStatus({ channel, status }) }
    : operations;

  return request.put({
    url: `/shops/${shopId}/products`,
    params: { db, editType: 'single', ...params },
    payload,
  });
}

export async function editLinkedProducts({
  db,
  existingProducts,
  linkId,
  newProducts,
  productsToEdit,
  shopId,
}) {
  return request.post({
    url: `/shop/${shopId}/${linkId ? 'editMergedProducts' : 'mergeNewProducts'}`,
    params: { db },
    payload: { existingProductsToMerge: existingProducts, newProducts, productsToEdit },
  });
}

export async function getInvalid({ attribute, channel, db, id, shopId, signal }) {
  switch (channel) {
    case EBAY:
    case FAIRE: {
      return request.post({
        endpoint: ENDPOINT.WEB_V2,
        params: { db },
        payload: { id, attribute },
        url: `/${channel}/shops/${shopId}/listings/invalid`,
        signal,
      });
    }

    default: {
      return request.post({
        params: { db },
        payload: { id, attribute },
        url: `/shops/${shopId}/products/invalid`,
        signal,
      });
    }
  }
}

export async function getInvalidCounts({ channel, db, id, shopId, signal }) {
  switch (channel) {
    case EBAY:
    case FAIRE: {
      return request.post({
        endpoint: ENDPOINT.WEB_V2,
        params: { db },
        payload: { id },
        url: `/${channel}/shops/${shopId}/listings/invalid/count`,
        signal,
      });
    }

    default: {
      return request.post({
        url: `/shops/${shopId}/products/invalid/count`,
        params: { db },
        payload: { id },
        signal,
      });
    }
  }
}

export async function search({ db, payload, shopId, signal }) {
  return request.put({
    url: `/shops/${shopId}/products/search`,
    params: { db },
    payload,
    signal,
  });
}

export async function deleteProducts({ channel, db, products, shopId }) {
  const operation = { type: 'products.delete', products };

  switch (channel) {
    case ETSY: {
      operation.channelId = CHANNEL_ID[ETSY];
      operation.shopId = shopId;
      operation.value = 'delete';
      break;
    }

    default: {
      break;
    }
  }

  return request.delete({
    params: { db },
    payload: [operation],
    url: `/shops/${shopId}/products`,
  });
}

export async function uploadFiles({ files }) {
  return request.post({
    payload: { files },
    url: '/digital_files/upload',
  });
}

export async function searchByTitle({ channel, db, limit, offset, shopId, signal, title }) {
  return request.get({
    endpoint: ENDPOINT.WEB_V2,
    params: { db, limit, offset, title },
    signal,
    url: `/${channel}/${shopId}/search`,
  });
}

export function bulkOverride({ db, listings, shopId, signal }) {
  return request.post({
    endpoint: ENDPOINT.BULK_OVERRIDE,
    params: { db },
    payload: { listing_ids: listings },
    signal,
    url: `/shops/${shopId}/bulk-override`,
  });
}
